import "./Privacy.css";
const headerStyle = {
  color: "#3A3A3A",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "bold",
  textDecoration: "none",
  fontSize: "12pt",
};

const paragraphStyle = {
  color: "#3A3A3A",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "normal",
  textDecoration: "none",
  fontSize: "12pt",
  margin: "0pt",
};

const DeletePolicy = () => {
  return (
    <div>
      <h1
        style={{
          paddingLeft: "17pt",
          textIndent: "-12pt",
          textAlign: "left",
          marginTop : "40px",
          fontSize:"30px",
          ...headerStyle,
        }}
      >
        Follow the below steps to delete an account in the App:-
      </h1>
      <ol style={{ paddingLeft: "20pt", textAlign: "left" }}>
        <li style={{ paddingBottom: "10pt", ...paragraphStyle }}>
         1. Login to your account.
        </li>
        <li style={{ paddingBottom: "10pt", ...paragraphStyle }}>
         2. Go to settings.
        </li>
        <li style={{ paddingBottom: "10pt", ...paragraphStyle }}>
         3. Click on the "Delete Account" button . After
          clicking "Delete" on the popup, all app account data will be deleted
          permanently.
        </li>
      </ol>
    </div>
  );
};

export default DeletePolicy;
